import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VDialog,
        {
          attrs: { "max-width": "800", persistent: "" },
          model: {
            value: _vm.visibilidade,
            callback: function ($$v) {
              _vm.visibilidade = $$v
            },
            expression: "visibilidade",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardText,
                [
                  _c(
                    VCard,
                    { attrs: { flat: "" } },
                    [
                      _c(
                        VForm,
                        {
                          ref: "form",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.onSubmit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            [
                              _c(VRow, [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "headline primary--text text-no-wrap",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isEdicao ? "Editar" : "Adicionar"
                                        ) +
                                        " Motivo de Dispensa "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(VRow, [
                                _vm._v(
                                  " Digite a descrição do motivo de dispensa a ser " +
                                    _vm._s(
                                      _vm.isEdicao ? "editado" : "adicionado"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                VRow,
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      autofocus: "",
                                      label: "Descrição",
                                    },
                                    model: {
                                      value: _vm.motivo.descricao,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.motivo,
                                          "descricao",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "motivo.descricao",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCardActions,
                            [
                              _c(VSpacer),
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    disabled:
                                      _vm.motivo.descricao.trim() === "",
                                    color: "primary",
                                    type: "submit",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isEdicao ? "Editar" : "Adicionar"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                VBtn,
                                {
                                  attrs: { color: "primary", outlined: "" },
                                  on: { click: _vm.toogle },
                                },
                                [_vm._v(" Cancelar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.motivos.length > 0
                    ? _c(
                        VCard,
                        { attrs: { flat: "" } },
                        [
                          _c(
                            VCardText,
                            { staticClass: "py-0" },
                            [
                              _c(VRow, [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "headline primary--text text-no-wrap",
                                  },
                                  [_vm._v("Motivos de Dispensa")]
                                ),
                              ]),
                              _c(VDataTable, {
                                attrs: {
                                  items: _vm.motivos,
                                  headers: _vm.headers,
                                  search: _vm.opcoes.pesquisa,
                                  "sort-by": _vm.opcoes.ordenarPor,
                                  "sort-desc": _vm.opcoes.decrescente,
                                  "items-per-page": 5,
                                  "item-key": "id",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "top",
                                      fn: function () {
                                        return [
                                          _c(
                                            VRow,
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                VCol,
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md: "4",
                                                  },
                                                },
                                                [
                                                  _c("app-sort", {
                                                    model: {
                                                      value: _vm.opcoes,
                                                      callback: function ($$v) {
                                                        _vm.opcoes = $$v
                                                      },
                                                      expression: "opcoes",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(VCol, {
                                                attrs: { cols: "0", md: "4" },
                                              }),
                                              _c(
                                                VCol,
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md: "4",
                                                  },
                                                },
                                                [
                                                  _c("app-search", {
                                                    model: {
                                                      value: _vm.opcoes,
                                                      callback: function ($$v) {
                                                        _vm.opcoes = $$v
                                                      },
                                                      expression: "opcoes",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: `item.acoes`,
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            VTooltip,
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        item.usuarioResponsavel
                                                          ? _c(
                                                              VBtn,
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    icon: "",
                                                                    small: "",
                                                                    color:
                                                                      "secondary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.editar(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c(VIcon, [
                                                                  _vm._v(
                                                                    "edit"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Clique no botão para editar a dispensa"
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            VTooltip,
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        item.usuarioResponsavel
                                                          ? _c(
                                                              VBtn,
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    small: "",
                                                                    color:
                                                                      "error",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.confirmarExclusao(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c(VIcon, [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Clique no botão para excluir a dispensa"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-remove", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dialogRemove.visibilidade,
            expression: "dialogRemove.visibilidade",
          },
        ],
        attrs: {
          "confirm-action": _vm.excluir,
          "dialog-visible": _vm.dialogRemove.visibilidade,
          "toogle-visible": _vm.toogleDialogRemove,
          descricao: "Você realmente deseja excluir esse motivo?",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }